var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2601_23869)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.280273,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#4B4AD5",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9466 13.6667C15.2353 13.6667 16.2799 12.622 16.2799 11.3333C16.2799 10.0447 15.2353 9 13.9466 9C12.658 9 11.6133 10.0447 11.6133 11.3333C11.6133 12.622 12.658 13.6667 13.9466 13.6667Z",
    stroke: "#4B4AD5",
    strokeWidth: 1.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1693 22.9987C21.4579 22.9987 22.5026 21.954 22.5026 20.6654C22.5026 19.3767 21.4579 18.332 20.1693 18.332C18.8806 18.332 17.8359 19.3767 17.8359 20.6654C17.8359 21.954 18.8806 22.9987 20.1693 22.9987Z",
    stroke: "#4B4AD5",
    strokeWidth: 1.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2793 11.332H24.8349",
    stroke: "#4B4AD5",
    strokeWidth: 1.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72461 11.332H11.6135",
    stroke: "#4B4AD5",
    strokeWidth: 1.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5029 20.668H24.8363",
    stroke: "#4B4AD5",
    strokeWidth: 1.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72461 20.668H17.8357",
    stroke: "#4B4AD5",
    strokeWidth: 1.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2601_23869"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.280273,
    width: 32,
    height: 32,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentFilter);
export default __webpack_public_path__ + "static/media/appointment-filter.588044f3e2895332fc0d0831e93cf619.svg";
export { ForwardRef as ReactComponent };